import { UserRole } from 'common/interfaces/common';

export const selectUserRole = (state): UserRole | null => state.getIn(['userRole', 'role']);
